import PatternBackground from "./PatternBackground.js";
import MainVisual from "./MainVisual.js";

document.addEventListener("DOMContentLoaded", () => {
  initScrollbarWidth();

  const background = document.querySelector("#bg");
  // #bgがない場合には、配置されるのを待つ
  if (!background) {
    const wait = setInterval(() => {
      const bg = document.querySelector("#bg");
      if (bg) {
        clearInterval(wait);
        initPatternBackground(bg);
        initMainVisual();
      }
    }, 100);
    return;
  } else {
    initPatternBackground(background);
    initMainVisual();
  }
});

/** スクロールバー幅をCSS変数にセット */
function initScrollbarWidth() {
  const width = window.innerWidth - document.documentElement.clientWidth;
  document.body.style.setProperty("--scrollbar-width", `${width}px`);
}

function initPatternBackground(background) {
  const canvas = document.createElement("canvas");
  canvas.id = "pattern";
  background.appendChild(canvas);

  // 描画に使う画像URLリスト
  const imageUrls = [
    "/n/s/wp-content/uploads/2025/05/img0.jpg",
    "/n/s/wp-content/uploads/2025/05/img1.jpg",
    "/n/s/wp-content/uploads/2025/05/img2.jpg",
    "/n/s/wp-content/uploads/2025/05/img3.jpg",
    "/n/s/wp-content/uploads/2025/05/img4.jpg",
    "/n/s/wp-content/uploads/2025/05/img5.jpg",
    "/n/s/wp-content/uploads/2025/05/img6.jpg",
    "/n/s/wp-content/uploads/2025/05/img7.jpg",
    "/n/s/wp-content/uploads/2025/05/img8.jpg",
    "/n/s/wp-content/uploads/2025/05/img9.jpg",
    "/n/s/wp-content/uploads/2025/05/img10.jpg",
    "/n/s/wp-content/uploads/2025/05/img11.jpg",
    "/n/s/wp-content/uploads/2025/05/img12.jpg",
    "/n/s/wp-content/uploads/2025/05/img13.jpg",
  ];
  const bg = new PatternBackground({
    canvas: canvas,
    images: imageUrls,
    colorSets: [
      ["#D6D2B2", "#CBBFD2"],
      ["#AFC8C3", "#D7BBA8"],
      ["#B7C4D0", "#D0B5B1"],
    ],
    imageChance: 0.25,
  });
  bg.start();
}

// MainVisualの初期化
function initMainVisual() {
  const keyVisualSelector = "#kv";
  const intervieweeNameImages = [
    {
      src: "/ns_mikinorihei_mizutaniyaeko/imgs_main/str_v4-0.png",
      tx: 1080,
      ty: 362,
      w: 51,
      h: 51,
      mtx: 281,
      mty: 476,
      mw: 34,
      mh: 34,
    },
    {
      src: "/ns_mikinorihei_mizutaniyaeko/imgs_main/str_v4-1.png",
      tx: 1080,
      ty: 413,
      w: 51,
      h: 51,
      mtx: 281,
      mty: 510,
      mw: 34,
      mh: 34,
    },
    {
      src: "/ns_mikinorihei_mizutaniyaeko/imgs_main/str_v4-2.png",
      tx: 1080,
      ty: 464,
      w: 51,
      h: 51,
      mtx: 281,
      mty: 544,
      mw: 34,
      mh: 34,
    },
    {
      src: "/ns_mikinorihei_mizutaniyaeko/imgs_main/str_v4-3.png",
      tx: 1080,
      ty: 515,
      w: 51,
      h: 51,
      mtx: 281,
      mty: 578,
      mw: 34,
      mh: 34,
    },
    {
      src: "/ns_mikinorihei_mizutaniyaeko/imgs_main/str_v4-4.png",
      tx: 1080,
      ty: 566,
      w: 51,
      h: 51,
      mtx: 281,
      mty: 612,
      mw: 34,
      mh: 34,
    },
    {
      src: "/ns_mikinorihei_mizutaniyaeko/imgs_main/str_v4-5.png",
      tx: 1080,
      ty: 617,
      w: 51,
      h: 51,
      mtx: 281,
      mty: 646,
      mw: 34,
      mh: 34,
    },
    {
      src: "/ns_mikinorihei_mizutaniyaeko/imgs_main/str_v4-6.png",
      tx: 1080,
      ty: 668,
      w: 51,
      h: 51,
      mtx: 281,
      mty: 680,
      mw: 34,
      mh: 34,
    },
    {
      src: "/ns_mikinorihei_mizutaniyaeko/imgs_main/str_v4-7.png",
      tx: 1080,
      ty: 719,
      w: 51,
      h: 51,
      mtx: 281,
      mty: 714,
      mw: 34,
      mh: 34,
    },
  ];
  const intervieweePhotoImage = {
    src: "/ns_mikinorihei_mizutaniyaeko/imgs_main/ph_main_namba.jpg",
    tx: 720,
    ty: 290,
    w: 360,
    h: 480,
    mtx: 0,
    mty: 374,
    mw: 280,
    mh: 374,
  };

  const mainVisual = new MainVisual({
    keyVisualSelector,
    intervieweeNameImages,
    intervieweePhotoImage,
  });
}
